var map = {
	"./alexandru-david.jpg": 58861,
	"./andrea-bellomia.jpg": 17910,
	"./bajram-hushi.jpg": 16786,
	"./carlo-vassallo.jpg": 81070,
	"./davide-cerato.jpg": 98466,
	"./kristian-notari.jpg": 71129,
	"./lorenzo-beccaro.jpg": 35216,
	"./marco-tanzola.jpg": 19915,
	"./michael-andolino.jpg": 54932,
	"./no_avatar.jpg": 4403,
	"./valerio-buzzelli.jpg": 28078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56751;